import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Column } from 'primereact/column'
import Button from '../../../components/ui/Button'
import { formatDate } from '../../../lib/datetime'
import { formatDuration } from '../duration'
import type { FlightRecord } from '../types'

interface ColumnOpts {
  t: TFunction
  busyId: number | null
  onEdit: (row: FlightRecord) => void
  onDelete: (row: FlightRecord) => void
}

/**
 * Uçuş Kaydı tablosunun sütunları: Tarih · Süre · Açıklama · işlemler. Kardeş sekmedeki kurallar
 * aynen geçerlidir (sunucu sırası, sıralanamaz başlıklar, biçimlenmiş süre).
 */
export function flightRecordColumns({ t, busyId, onEdit, onDelete }: ColumnOpts): ReactElement[] {
  const durationLabels = {
    hour: t('timePortfolio.duration.hour'),
    minute: t('timePortfolio.duration.minute'),
  }
  return [
    <Column
      key="date"
      header={t('timePortfolio.flight.columns.date')}
      style={{ width: '10rem' }}
      body={(row: FlightRecord) => formatDate(row.flightDate)}
    />,
    <Column
      key="duration"
      header={t('timePortfolio.flight.columns.duration')}
      style={{ width: '10rem' }}
      body={(row: FlightRecord) => formatDuration(row.durationMinutes, durationLabels)}
    />,
    <Column
      key="description"
      header={t('timePortfolio.flight.columns.description')}
      body={(row: FlightRecord) => row.description ?? ''}
    />,
    <Column
      key="actions"
      header={t('timePortfolio.columns.actions')}
      style={{ width: '8rem' }}
      body={(row: FlightRecord) => {
        const label = formatDate(row.flightDate)
        return (
          <div className="admin-row-actions">
            <Button
              icon="pi pi-pencil"
              rounded
              text
              aria-label={t('timePortfolio.actions.editNamed', { name: label })}
              tooltip={t('timePortfolio.actions.edit')}
              tooltipOptions={{ position: 'bottom' }}
              onClick={() => onEdit(row)}
            />
            <Button
              icon="pi pi-trash"
              rounded
              text
              severity="danger"
              aria-label={t('timePortfolio.actions.deleteNamed', { name: label })}
              tooltip={t('timePortfolio.actions.delete')}
              tooltipOptions={{ position: 'bottom' }}
              disabled={busyId === row.id}
              onClick={() => onDelete(row)}
            />
          </div>
        )
      }}
    />,
  ]
}
